/**
 * Slot seed derivation — Plan 08-03 Task 2.
 *
 * per-reel seed = `${donationEventId}:${reelIndex}`, jackpot seed = `${eventId}:jackpot`.
 * 릴마다 독립 RNG 로 weighted symbol pick.
 */
import { createSeededRng, type SeededRng } from '../seeded-rng.js';

export function createSlotReelRng(donationEventId: string, reelIndex: number): SeededRng {
  return createSeededRng(`${donationEventId}:reel-${reelIndex}`);
}

export function createSlotJackpotRng(donationEventId: string): SeededRng {
  return createSeededRng(`${donationEventId}:jackpot`);
}
